import { useMemo } from "react";
import { useApiList } from "@/queries/base/useApiList";

/**
 * Fetches all Part Platforms as react-select options.
 * GET /part_platform
 *
 * @returns {{ options: Array<{value, label}>, isLoading: boolean, error: string|null }}
 */
export function usePartPlatforms(deps = []) {
  const { data, isLoading, error } = useApiList("/part_platform", [deps]);

  const options = useMemo(() => {
    return data.map((obj) => ({ value: obj.id, label: obj.name }));
  }, [data]);
  return { options, isLoading, error };
}
